module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-home-9ee9d2535c34977f65764134599f7fb6.jpg";